import state from '@bingads-webui-component-legacy/state/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import { queryify } from '@bingads-webui/url-util';

function getProductData(resolve, isMranSimplificationV2Enable) {
  let url = queryify('/Campaign/NewCampaign/GetProductScope', {
    aid: state.get('account_id'),
    cid: state.get('customer_id'),
    uid: state.get('user_id'),
  });

  if (isMranSimplificationV2Enable) {
    url = queryify(url, {
      getCategoryFullData: true,
    });
  }

  const params = {
    url,
    adapter: 'legacy',
    bypassCache: false,
    cacheResponse: true,
  };


  const p = jsdata.Product.find('MetaData', params);
  resolve();
  return p;
}

export function fetchDataForShoppingCampaignCreationPage(resolve, isMranSimplificationV2Enable) {
  return getProductData(resolve, isMranSimplificationV2Enable);
}
